import dayjs, { Dayjs } from 'dayjs';

import {
  DEVIATION_THRESHOLD_MINUTES,
  HIGH_HOURS_THRESHOLD,
  MINUTES_PER_HOUR,
  UNUSUAL_HOURS_END,
  UNUSUAL_HOURS_START,
} from './bookingConstants';

export const convertMinutesToHours = (minutes: number): number => {
  return Number((minutes / MINUTES_PER_HOUR).toFixed(2));
};

export const calculateDeviation = (
  originalDuration: number | null,
  confirmedDuration: number | null
): number => {
  if (!originalDuration || !confirmedDuration) {
    return 0;
  }
  return Math.abs(confirmedDuration - originalDuration);
};

export const calculateDurationInMinutes = (
  startDate: string,
  startTime: string,
  endDate: string,
  endTime: string
): number | null => {
  if (!startDate || !startTime || !endDate || !endTime) {
    return null;
  }
  const combinedStart = `${startDate}T${startTime}`;
  const combinedEnd = `${endDate}T${endTime}`;
  return dayjs(combinedEnd).diff(combinedStart, 'minute');
};

export const hasHighHoursWarning = (durationMinutes: number): boolean => {
  const hours = convertMinutesToHours(durationMinutes);
  return hours >= HIGH_HOURS_THRESHOLD;
};

export const hasDeviationWarning = (
  originalDuration: number | null,
  confirmedDuration: number
): boolean => {
  if (!originalDuration) return false;
  const deviation = calculateDeviation(originalDuration, confirmedDuration);
  return deviation > DEVIATION_THRESHOLD_MINUTES;
};

export const isUnusualHour = (date: Dayjs | null): boolean => {
  if (!date) return false;
  const hour = date.hour();
  return hour >= UNUSUAL_HOURS_START || hour < UNUSUAL_HOURS_END;
};
